import React from 'react';
import { Layout, Drawer, Icon, Tag, Button, Row, Col, message, notification } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import auth from '../common/utility/auth';
import dialog from '../common/utility/dialog';
import global from '../common/utility/global';
import signalRBase from '../common/utility/signalRBase';
import { connectToStockHub, openSock, disconnectStockHub } from '../common/utility/signalRNotify';

import MainHeader from './MainHeader';
import Routers from './Routers';
import TopMenu from './TopMenu';
import FormModal from './FormModal';
import LayoutNotification from './LayoutNotification';

import { mainOptionsMock } from '../common/mock/mainOptionsMock';
import { SERVICE_MANAGER_API_HUB, ERP } from '../service/_base/endpoint';
import { VISUAL_PLAN } from "../../src/common/types/parametroType";


const { Content } = Layout;


export default class AppLayout extends React.Component {
    constructor(props) {
        // const selectedApplication = localStorage.getItem('selectedApplication') ? localStorage.getItem('selectedApplication') : '';
        // const
        super(props)
        this.state = {
            openKeys: [],
            modulos: [],
            aplicaciones: [],
            notifications: [],
            notificationCount: 0,
            aplicacion: undefined,
            user: undefined,
            plan: '',
            selectedPage: '',
            visibleApps: false,
            visible: false,
            breadcrumb: {
                aplicacion: '',
                modulo: '',
                pagina: ''
            },
            visiblePlan: false,// auth.user().parametros.filter(m => m.abreviatura === VISUAL_PLAN)[0].valor === "1" ? true : false,
            notificationOpen: false,
        }
    }

    handleOpenChange = openKeys => {
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        this.setState({
            openKeys: latestOpenKey ? [latestOpenKey] : [],
        });
    };

    handleSignout = () => {
        localStorage.removeItem('user');
        signalRBase.close();
        disconnectStockHub();
        this.setState({ update: true });
    };

    handleChangeAplicacion = (aplicacion) => {
        this.setState({
            aplicacion,
            modulos: aplicacion.modulos,
            visibleApps: false
        });
    };

    handleChangePage = (selectedPage) => {
        this.setState({ selectedPage });
    };

    handleSetBreadcrumb = (path) => {
        const filter = auth.user().pages.filter(m => { return m.url === path })[0];

        this.setState({
            breadcrumb: {
                aplicacion: filter.breadcrumb.split('|')[0],
                modulo: filter.breadcrumb.split('|')[1],
                pagina: filter.breadcrumb.split('|')[2]
            }
        });
    };

    onSignalRImlementation = () => {
        signalRBase.init({
            url: `${SERVICE_MANAGER_API_HUB}hub`,
            userName: auth.user().userName,
            userGroup: auth.user().userGroup,
            session: auth.user().session,
            device: global.getDeviceType(),
            system: auth.user().systemCode,
            entity: auth.user().ruc,
            integrationCode: auth.user().integrationCode,
            groups: [auth.user().userGroup, auth.user().mainGroup, auth.user().session]
        });

        var genericNotification = message => {
            localStorage.removeItem('user');
            signalRBase.close();
            dialog.info(message, () => this.setState({ update: true }));
        };

        signalRBase.on("acsoft-erp-discontinued-event", genericNotification);

        signalRBase.on("acsoft-erp-close-connection", genericNotification);

        signalRBase.on("acsoft-erp-user-limit", (message) => {
            localStorage.removeItem('user');
            signalRBase.close();
            try {
                var obj = JSON.parse(message);
                dialog.infoTitle(obj.title, obj.message, () => this.setState({ update: true }));
            } catch (error) {
                dialog.info(message, () => this.setState({ update: true }));
            }
        });
    };

    openInNewTab = (url) => {
        //window.open(url, "_blank", "noreferrer");
        this.setState({ visible: true });
    };

    componentDidMount() {
        if (auth.isAuthenticated()) {

            var visiblePlan = auth.user().parametros.filter(m => m.abreviatura === VISUAL_PLAN)[0].valor === "1" ? true : false;

            try {
                var user = auth.user();
                var plan = '';
                var selectedApplication = localStorage.getItem('selectedApplication') ? localStorage.getItem('selectedApplication') : '';
                var selectedPage = localStorage.getItem('selectedPage') ? localStorage.getItem('selectedPage') : '';
                var aplicacion = user.aplicaciones.length === 0 ? undefined : user.aplicaciones[0];
                var modulos = user.aplicaciones.length === 0 ? [] : user.aplicaciones[0].modulos;

                switch (user.planCode) {
                    case 'PLA001':
                        plan = 'Emprendedor';
                        break;
                    case 'PLA002':
                        plan = 'MYPE';
                        break;
                    case 'PLA003':
                        plan = 'PYME';
                        break;
                    default:
                        plan = '';
                        break;
                }


                if (user.aplicaciones.length > 0 && selectedApplication !== '') {
                    var aplicacionLS = user.aplicaciones.filter(m => m.id === parseInt(selectedApplication))[0];
                    aplicacion = aplicacionLS === undefined ? user.aplicaciones[0] : aplicacionLS;
                    modulos = aplicacion.modulos;
                }

                this.setState({
                    aplicaciones:
                        user.aplicaciones,
                    aplicacion,
                    user,
                    plan,
                    modulos,
                    visiblePlan: visiblePlan,
                    selectedPage
                });
            } catch (error) {
                console.log(error);
            }

            this.onSignalRImlementation();

            var notificationExpiration = message => {

                if (JSON.parse(message).length > 0) {
                    this.setState({
                        notifications: JSON.parse(message),
                        notificationCount: JSON.parse(message).length,
                    });
                    this.info("📝 Tienes productos vencidos para mas detalle revisa el reporte");
                }
            };

            var notificationStock = message => {

                if (JSON.parse(message).length > 0) {
                    this.setState({
                        notifications: JSON.parse(message),
                        notificationCount: JSON.parse(message).length,
                    });
                    this.info("📦 Tienes productos sin stock para mas detalle revisa el reporte");
                }
            };
            connectToStockHub(auth.user().userName, auth.user().session, `${ERP}stockHub`)
                .then(() => {
                    console.log("🟢 Conexión establecida correctamente");
                    // Suscribirse al evento
                    openSock("sms_expiration", notificationExpiration);

                    openSock("sms_stock", notificationStock);

                })
                .catch(err => {
                    console.error("❌ Error al conectar al Hub:", err);
                });
        }
    };

    info = (sms) => {
        message.info(sms);
    };

    onCloseNotification = () => {
        this.setState({
            notificationOpen: false,
            notificationCount: 0
        });
    };

    onShowNotification = async () => {
        this.setState({
            notificationOpen: true,
            notificationCount: 0

        });
    };

    render() {
        if (!auth.isAuthenticated())
            return <Redirect to='/auth' />

        return (
            <Layout>
                <MainHeader
                    onSignout={this.handleSignout}
                    aplicacion={this.state.aplicacion}
                    mainOptions={mainOptionsMock}
                    user={this.state.user}
                    notificationCount={this.state.notificationCount}
                    onShowNotification={this.onShowNotification}
                />
                <TopMenu
                    selectedPage={this.state.selectedPage}
                    modulos={this.state.modulos}
                    onChange={this.handleChangePage}
                    onOpenApps={() => this.setState({ visibleApps: true })}
                />
                <Content className="content-body" style={{ marginTop: '16px' }}>
                    <Routers onSetBreadcrumb={this.handleSetBreadcrumb} />
                </Content>
                <Drawer
                    title={
                        <div>
                            <span style={{ color: '#5D6F81', fontSize: '18px' }}><Icon type="appstore" theme="twoTone" /> Aplicaciones</span><br /> <br />
                            <div style={{ textAlign: 'center' }}
                                role='link'>

                                {this.state.visiblePlan ?
                                    <div onClick={() => this.openInNewTab("https://plainenglish.io")}>
                                        <Button type="primary" ghost>ACSOFT ERP {this.state.plan}</Button><br />
                                        <span><Icon type="eye" style={{ fontSize: '21px' }} theme="twoTone" />
                                            <Tag color={'#2db7f5'} style={{ marginTop: 10, marginLeft: 10 }}> + Planes</Tag>
                                        </span>
                                    </div> : null
                                }

                            </div>
                        </div>
                    }
                    placement={"left"}
                    onClose={() => this.setState({ visibleApps: false })}
                    visible={this.state.visibleApps}
                    width={350}
                >
                    <div className="layout-content-item-apps text-center" key="asds">
                        <Row gutter={[2, 10]}>
                            {
                                (this.state.user ? this.state.user.aplicaciones : []).map(item => (
                                    <Col span={12} key={item.id}>
                                        <Link key={item.id} to="/">
                                            <div
                                                key={item.id}
                                                className="text-center layout-item-apps mb-10"
                                                onClick={() => {
                                                    this.handleChangeAplicacion(item);
                                                    localStorage.setItem('selectedApplication', item.id);
                                                }}
                                                style={{ backgroundColor: '#1890ff', color: '#ffffff' }}
                                            >
                                                {
                                                    item.iconoPersonalizado ?
                                                        /*   <img
                                                              src={require('../assets/images/' + item.icono)}
                                                              style={{ width: "40px", marginBottom: '3px' }}
                                                              alt="icon"
                                                          /> */
                                                        <Icon type={item.icono} style={{ fontSize: '40px', color: '#ffffff' }} theme="outlined" />
                                                        :
                                                        <Icon type="shopping" style={{ fontSize: '40px', color: '#ffffff' }} theme="outlined" />
                                                    //<Icon type={item.icono} />
                                                }
                                                <p>{item.nombre}</p>
                                            </div>
                                        </Link>
                                    </Col>
                                ))
                            }
                        </Row>
                    </div>
                </Drawer>

                <FormModal
                    visible={this.state.visible}
                    onClose={() => this.setState({ visible: false })}
                    onSave={() => this.setState({ visible: false })}
                />

                <LayoutNotification
                    source={this.state.notifications}
                    open={this.state.notificationOpen}
                    onClose={this.onCloseNotification}
                />
            </Layout>
        );
    }
}